/***
 * Proxy implementation
 */
Atheneum.Proxy = function AtheneumProxy(atheneum, enabled) {

    if (!(this instanceof Atheneum.Proxy))
        return new Atheneum.Proxy(enabled);

    this.enabled = enabled;
}

Atheneum.Proxy.prototype.rewriteURL = function (url) {

    //return url;

    if (!this.enabled || !url)
        return '' + url;

    if (typeof url === 'string' && url.startsWith('/'))
        url = (window.location.protocol + '//' + window.location.host) + url;

    try {
        if (!(url instanceof URL))
            url = new URL(url);
    } catch (e) {
        // it's a relative url, or a broken one. Just return it.
        return url;
    }

    if (url.origin == (window.location.protocol + '//' + window.location.host))
        return url.href;

    var match = url.pathname.match(/\/restful\/[0-9A-Fa-f]+\/stories\/([0-9A-Fa-f]+)\/image\.(.+)/);
    if (match) {
        return window.location.protocol + '//' + window.location.host + '/restful/imageCache/story/' + match[1];
    }

    match = url.pathname.match(/\/restful\/[0-9A-Fa-f]+\/stories\/[0-9A-Fa-f]+\/([0-9A-Fa-f]+)\/thumb\.(.+)/);
    if (match) {
        return window.location.protocol + '//' + window.location.host + '/restful/imageCache/asset/' + match[1];
    }

    match = url.pathname.match(/\/dms\/public\/image\/([0-9A-Fa-f]+)\.(.+)/);
    if (match) {
        return window.location.protocol + '//' + window.location.host + '/restful/imageCache/generic/' + match[1];
    }

    return window.location.protocol + '//' + window.location.host + '/proxy/' + url.protocol.substring(0, url.protocol.length - 1) + '/' + url.host + url.pathname + url.search + url.hash;
}

Atheneum.Proxy.prototype.convertImageToBase64 = function (fileUpload, callback) {

    var successCallback = typeof callback === "function" ? callback : callback.success;

    var form = fileUpload.parentNode;
    //var prevNode = fileUpload.previousSibling;

    while (form && form.tagName.toUpperCase() != "FORM")
        form = form.parentNode;

    if (form == null) {
        // give up
        return;
    }

    var iframeHolder = document.createElement('DIV');
    iframeHolder.style.display = 'none';
    document.body.appendChild(iframeHolder);

    iframeHolder.innerHTML = '<iframe id="atheneum-ie9-file-uploader" name="atheneum-ie9-file-uploader"></iframe>';
    var iframe = iframeHolder.children[0];

    form.setAttribute('target', 'atheneum-ie9-file-uploader')

    iframe.onload = function () {

        var iframeDocument = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        if (!iframeDocument || !iframeDocument.body)
            return;

        if (!iframeDocument.documentURL || iframeDocument.documentURL == "javascript: false")
            return;

        var base64imageData = iframeDocument.body.innerHTML;
        document.body.removeChild(iframeHolder);

        if (typeof successCallback === "function")
            successCallback(base64imageData);
    }

    form.submit();
}

console.log("atheneumAPI.Proxy.js - loaded");